import BaseResource from './index'
import AgreementResource from './agreement'
import JobTitleResource from './jobTitle'
import UnionLocalResource from './unionLocal'
import UnionJurisdictionResource from './unionJurisdiction'
import OnProductionResource from './onProduction'
import ScheduleResource from './schedule'

export default class UnionRulesetResource extends BaseResource {
    static endpoint = '/oasis/restv3/admin/unionRulesets'
    static cacheMaxAge = 60

    static related() {
        return {
            agreement_id: AgreementResource,
            job_title_id: JobTitleResource,
            union_local_id: UnionLocalResource,
            jurisdiction_id: UnionJurisdictionResource,
            schedule_id: ScheduleResource,
            on_prod_id: OnProductionResource,
        }
    }
}
